import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-12 md:py-20 px-4 bg-cream relative overflow-hidden" data-id="element-143">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-145">
          <h2 className="text-3xl md:text-4xl mb-6" data-id="element-146">
            Vivir con un gato en un departamento chico en Argentina (donde los
            espacios son sagrados y los muebles caros) puede ser una{' '}
            <span className="text-amber" data-id="element-147">pesadilla silenciosa.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-148">
          {['El gato maúlla a las 3 de la mañana como si lo estuvieran matando.', 'Tira las macetas del balcón.', 'Rasca el sommier hasta que se ve la madera.', 'Y vos terminás gritándole, sintiéndote mal, y comprando rascadores de peluche de $60.000 que él ignora olímpicamente para seguir usando tu cortina de back-out.'].map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm flex items-start gap-4" data-id="element-149">
              <AlertCircle className="text-amber shrink-0 mt-1" size={24} data-id="element-150" />
              <p className="text-lg text-warmBrown/90" data-id="element-151">{text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-152">
          <p className="font-heading text-2xl md:text-3xl text-warmBrown" data-id="element-153">
            El problema no es tu gato. <br className="hidden md:block" data-id="element-154" />
            <span className="text-amber" data-id="element-155">
              Es que tu casa es un desierto de estímulos para él.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}